import { Component, inject, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent implements OnInit {
  private _router: Router = inject(Router);
  private _translateService: TranslateService = inject(TranslateService);
  constructor() {
  }

  ngOnInit(): void {
  }

  goToHome(): void {
    const currentLang: string = this._translateService.currentLang;
    this._router.navigate([`/${currentLang}/`]);
  }
}
